// extracted by mini-css-extract-plugin
export default {"form":"StudentReviewModal_form__DP5TD"};